export default __webpack_public_path__ + "static/media/video.5f55925d.mp4";